import React, { useState } from "react";
import { editIcon, deletedIcon } from "../../../../assets/images/index.js";
import Pagination from "./pagination.jsx";
import TableActions from "./TableActions.jsx";
import "../../custom-components.style.scss";
import PropTypes from "prop-types";

const DataTable = ({
  headers,
  body,
  onPageChange,
  onGetLimit,
  count,
  hasAction,
  onEdit,
  onDelete,
  headerBtn,
  isPagination,
  headerBtnWidth,
}) => {
  const [state, setState] = useState({
    limit: 10,
  });

  const handleOnChangeLimit = (limit) => {
    onGetLimit(limit);

    setState({ ...state, limit: limit });
  };

  return (
    <>
      {hasAction && (
        <TableActions
          onGetLimit={(limit) => handleOnChangeLimit(limit)}
          limit={state.limit}
          headerBtn={headerBtn}
          headerBtnWidth={headerBtnWidth}
        />
      )}

      <div className="table_wrapper custom_scroll Appscroll p-0-5">

        <table className="table-hover">
          <thead>
            <tr className="thead">
              {headers?.map((header) => (
                <th
                  key={`${header.text}${header.key}`}
                  className={
                    header?.className ? `${header.className}` : "thead"
                  }
                >
                  {header.text}
                </th>
              ))}
            </tr>
          </thead>
          {body?.length > 0 ? (
            <tbody>
              {body.map((row, index) => (
                <tr key={`tr${index}`}>
                  {headers.map((header, index) =>
                    header?.component ? (
                      <td key={ index }
                        className={
                          header?.noDataCenter ? "" : "tdico "
                        }
                      >
                        {header?.component(row)}
                      </td>
                    ) : header.value === "action" ? (
                      header?.action?.isDeleteEnabled ? (
                        <td className="table_icon">
                          <a
                            title="Delete"
                            onClick={() => onDelete(row)}
                            className="delete_cmdb"
                          >
                            <img src={deletedIcon} alt="Delete" />
                          </a>
                        </td>
                      ) : (
                        <td className="table_icon">
                          <table className="action">
                            <tbody>
                              <tr>
                                <td>
                                  <a onClick={() => onEdit(row)} title="Edit" data-testid="table-edit-link">
                                    <img src={editIcon} alt="Edit" />
                                  </a>
                                </td>

                                <td>
                                  <a
                                    title="Delete"
                                    onClick={() => onDelete(row)}
                                    className="delete_cmdb"
                                    data-testid="table-delete-link"
                                  >
                                    <img src={deletedIcon} alt="Delete" />
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      )
                    ) : (
                      <td
                        className={
                          header?.dataClassName ? header.dataClassName : ""
                        }
                      >
                        {row[header.value]}
                      </td>
                    )
                  )}
                </tr>
              ))}
            </tbody>
          ) : (
            <tr>
              <td className="projectemty" colSpan="8">No Data Available</td>
            </tr>
          )}
        </table>
      </div>

      {isPagination && (
        <Pagination
          rows={body}
          onPageChange={(page) => onPageChange(page)}
          totalPages={Math.ceil(count / state.limit)}
        />
      )}
    </>
  );
};
  DataTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.object).isRequired,
  body: PropTypes.arrayOf(PropTypes.object).isRequired,
  onPageChange: PropTypes.arrayOf(PropTypes.object).isRequired,
  onGetLimit: PropTypes.arrayOf(PropTypes.object).isRequired,
  count: PropTypes.arrayOf(PropTypes.object).isRequired,
  hasAction: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEdit: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDelete: PropTypes.arrayOf(PropTypes.object).isRequired,
  headerBtn: PropTypes.arrayOf(PropTypes.object).isRequired,
  isPagination: PropTypes.arrayOf(PropTypes.object).isRequired,
  headerBtnWidth: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DataTable;



